// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"4c2b3cc2","601":"d53420a5","975":"b07a5b1f"}[chunkId] + ".chunk.js";
};